import fetch from './http';

// 登陆
export const userLogin = (data) => {
  return fetch({
    url: '/customer/login',
    method: 'POST',
    data
});
}
// 退出登陆
export const loginOut = (data) => {
  return fetch({
    url: '/customer/loginOut',
    method: 'POST',
    data
});
}

// 修改账户信息
export const modifyInfo = (data) => {
  return fetch({
    url: '/customer/modifyInfo',
    method: 'POST',
    data
});
}


// 修改账户信息
export const modifyPwd = (data) => {
  return fetch({
    url: '/customer/modifyPwd',
    method: 'POST',
    data
});
}


// 用户信息
export const queryCustomerInfo = (data) => {
  return fetch({
    url: '/customer/queryOne',
    method: 'POST',
    data
});
}

// 用户信息
export const queryPayFlowList = (data) => {
  return fetch({
    url: '/payFlow/queryPayFlowList',
    method: 'POST',
    data
});
}
// 修改头像
export const updateheadimage = (params) => {
  return http.fetchPost('/member/updateheadimage', params)
}
// 捐赠列表
export const thanksList = (params) => {
  return http.fetchGet('/member/thanks', params)
}
// 首页接口
export const productHome = (params) => {
  return http.fetchGet('/goods/productHome', params)
}
// 极验验证码
export const geetest = (params) => {
  return http.fetchGet('/member/geetestInit?t=' + (new Date()).getTime(), params)
}




// WEBPACK FOOTER //
// ./src/api/index.js